import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';

import constants from '../../../../constants';
import ReincorporationInfoView from './ReincorporationInfoView';
import { handleSelectRequest } from '../../../../ProceduresViewController';
import useTitle from '@/presentation/hooks/useTitle';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';
import routes from '@/presentation/components/Routes/routingMap';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const ReincorporationInfoViewController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params: any = useParams();
  const goToSelectRequest = handleSelectRequest();

  const {
    procedure: procedureSelectedInfo,
    selectedProcedureId,
    isLoading
  } = useSelector((state: any) => state.procedureInformation);

  const { procedureWhiteList } = useExternalSettings();

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showExistsModal, setShowExistsModal] = useState(false);
  const [showNotAvailableModal, setShowNotAvailableModal] = useState(false);
  const [showNotRequiredModal, setShowNotRequiredModal] = useState(false);

  useEffect(() => {
    GoogleAnalytics.writeLog(`portal-procedure-reincorporation`, 'portal');
    if (!procedureSelectedInfo && !isLoading) {
      const selectedRequest: any =
        constants.categories.requests.procedureList.find(
          (p: any) => p.url === params.reincorporation
        );
      dispatch(
        procedureActions.getProcedureInformation(
          selectedRequest?.procedureId ||
            constants.categories.requests.procedures.reincorporation
        )
      );
    }
  }, []);

  const handlerRequest = () => {
    if (procedureSelectedInfo.disabled) {
      setShowNotAvailableModal(true);
      return;
    }
    if (procedureSelectedInfo.currentRequestId > 0) {
      setShowExistsModal(true);
      return;
    }
    if (procedureSelectedInfo.error) {
      setShowErrorModal(true);
      return;
    }
    if (!procedureSelectedInfo.isReincorporated === true) {
      setShowNotRequiredModal(true);
      return;
    }
    history.push(
      '/tramites/autogestionables/solicitud/reincorporacion/registrar'
    );
  };

  const goToCurrentRequest = () => {
    goToSelectRequest.execute(
      procedureSelectedInfo.currentRequestId,
      procedureSelectedInfo.id
    );
  };

  const goBack = () => {
    history.goBack();
  };

  if (
    selectedProcedureId !== undefined &&
    procedureWhiteList?.length > 0 &&
    !procedureWhiteList?.includes(selectedProcedureId?.toString())
  ) {
    history.push(routes.student.procedures.home);
  }

  useTitle('Reincorporación');

  return (
    <ReincorporationInfoView
      procedureSelectedInfo={procedureSelectedInfo}
      handlerRequest={handlerRequest}
      goBack={goBack}
      errorModal={{ showErrorModal, setShowErrorModal }}
      existsModal={{ showExistsModal, setShowExistsModal }}
      notRequiredModal={{ showNotRequiredModal, setShowNotRequiredModal }}
      notAvailableModal={{ showNotAvailableModal, setShowNotAvailableModal }}
      goToCurrentRequest={goToCurrentRequest}
    />
  );
};

export default ReincorporationInfoViewController;
